"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require('./visualCodeBlock.css');const l="_visualBlock_11zyf_5",e={visualBlock:l};exports.default=e;exports.visualBlock=l;
//# sourceMappingURL=visualCodeBlock.module.css.cjs.map
